/**
 * CookieNotification Library
 *
 * @module CookieNotification
 */
(function CookieNotification() {
    /**
     * visibility handling of cookie message
     * @class {cookieNotification}
     * @constructor
     */
    function cookieNotification($dom) {

        /**
         * // local object availability
         * @type {cookieNotification}
         * @private
         */
        var _this = this;

        /**
         * @method cacheDom
         *  assign {jQuery|HTMLElement(s)} to object
         */
        this.cacheDom = function () {
            this.button = $dom.find('[data-cookie="button"]');
        };

        /**
         * visibility and behavior of cookie message
         * @method cookieProcessor
         * @returns {undefined}
         */
        this.cookieProcessor = function () {
            if (document.cookie.indexOf('allowCookies' + '=true') <= -1) {
                $dom.removeClass('hidden');
                _this.button.click(function () {
                    console.log('button is clicked');
                    var expiryDate = new Date();
                    // set date 6 month in future
                    expiryDate.setMonth(expiryDate.getMonth() + 5);
                    document.cookie = 'allowCookies' + '=true; expires=' + expiryDate.toGMTString() + '; path=/';
                    $dom.addClass('hidden');
                });
            }
        }

        /**
         * @method init
         * @returns {undefined}
         */
        this.init = function () {
            _this.cacheDom();
            _this.cookieProcessor();
        };

        /**
         * initialize call
         */
        _this.init();
    }

    // define the global scope
    if (!window.TechDivision) {
        window.TechDivision = {};
    }

    window.TechDivision.cookieNotification = cookieNotification;
})();

$(document).ready(function () {
    var $cookieNotificationWrapper = $('[data-cookie="wrapper"]');
    if ($cookieNotificationWrapper.length) {
        new window.TechDivision.cookieNotification($cookieNotificationWrapper);
    }
});